import React, { useState, useEffect, useMemo } from "react";
import Employee from "./Employee";
import Assignments from "./Assignments";
import { useParams } from "react-router-dom";
import { Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import {
  buildEmployeeDetailInformationRoute,
  buildEmployeeAssignmentsRoute,
  buildEmployeeDetailTranscriptRoute,
  buildEmployeeIltRoute
} from "../../routes/AdminRoutes";
import AdminPageLayout from "../../components/FullPageLayout/AdminPageLayout";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { useEmployee } from "../../hooks/employees";
import usePermissions from "../../redux/selectors/usePermissions";
import Tabs from "../../components/Tabs/Tabs";
import EmployeeTranscript from "./EmployeeTranscript";
import EmployeeIlts from "./EmployeeIlts";
import { administrationEmployees } from "../../routes/AdminRoutes";
import { Box } from "@mui/material";

const EmployeeContainer = props => {
  const { employeeID } = useParams();
  const [currentTab, setCurrentTab] = useState(0);
  const { employee, isLoading } = useEmployee(employeeID);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { history, location } = props;

  const {
    isAdmin,
    isGoldOrPlatinum,
    allowCustomRoleILTEnrollments,
    canViewEmployeeAssignments
  } = usePermissions();

  const tabs = useMemo(
    () =>
      [
        {
          label: t("administration.tabs.employeeInfoTab"),
          path: buildEmployeeDetailInformationRoute(employeeID)
        },
        {
          label: t("administration.tabs.assignmentsTab"),
          path: buildEmployeeAssignmentsRoute(employeeID),
          hidden: !canViewEmployeeAssignments
        },
        {
          label: t("administration.tabs.transcriptTab"),
          path: buildEmployeeDetailTranscriptRoute(employeeID)
        },
        {
          label: t("administration.tabs.iltTab"),
          path: buildEmployeeIltRoute(employeeID),
          hidden: !(isAdmin || allowCustomRoleILTEnrollments),
          disabled: !isGoldOrPlatinum,
          tooltip: !isGoldOrPlatinum
            ? t("administration.goldPlatinumFeatureTooltip")
            : ""
        }
      ].filter(tab => !tab.hidden),
    []
  );

  useEffect(() => {
    const currentPathIndex = tabs.findIndex(
      tab => tab.path === location.pathname
    );
    if (currentPathIndex !== -1) {
      setCurrentTab(currentPathIndex);
    }
  }, [location]);

  const handleTabChange = newTab => {
    setCurrentTab(newTab);
    history.push(tabs[newTab].path);
  };

  const handleGoBack = () => {
    dispatch(push(administrationEmployees));
  };

  useEffect(() => {
    setCurrentTab(
      tabs.findIndex(({ path }) => path === history.location.pathname)
    );
  }, []);

  return (
    <AdminPageLayout
      title={
        <Breadcrumb
          routes={[t("administration.employees"), employee?.fullName]}
        />
      }
      onGoBackClick={handleGoBack}
    >
      <Tabs
        tabs={tabs}
        currentTab={currentTab}
        onChange={newTab => handleTabChange(newTab)}
        variant="scrollable"
        textVariant="h6"
      />
      <Box mt={3}>
        <Route
          exact
          path={buildEmployeeDetailInformationRoute(employeeID)}
          render={props => {
            return (
              <Employee
                employeeID={employeeID}
                employee={employee}
                isLoading={isLoading}
                {...props}
              />
            );
          }}
        />
        <Route
          exact
          path={buildEmployeeAssignmentsRoute(employeeID)}
          render={props => {
            return <Assignments employeeID={employeeID} />;
          }}
        />
        <Route
          exact
          path={buildEmployeeDetailTranscriptRoute(employeeID)}
          render={props => {
            return <EmployeeTranscript employeeId={employeeID} />;
          }}
        />
        <Route
          exact
          path={buildEmployeeIltRoute(employeeID)}
          render={props => {
            return <EmployeeIlts employeeId={employeeID} />;
          }}
        />
      </Box>
    </AdminPageLayout>
  );
};

export default withRouter(EmployeeContainer);
